import axiosInstance from "../axiosInstance";

export const variantAttributeService = {
  /**
   * Fetch all unique option types (attribute types)
   * Returns: { data: [{ option_type: "Color" }, ...], total: N }
   */
  fetchOptionTypes: async (client_id, search = "", limit = 50, skip = 0) => {
    try {
      let query = `$limit=${limit}&$skip=${skip}&$select[]=option_type`;
      if (client_id) query += `&values.client_id=${client_id}`;
      if (search) query += `&option_type[$search]=${search}`;

      const response = await axiosInstance.get(`/variant-attribute?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Fetch all values for a specific option type
   * Returns: { data: [{ value: "Red" }, ...], total: N }
   */
  fetchOptionValues: async (
    optionType,
    client_id,
    search = "",
    limit = 50,
    skip = 0,
  ) => {
    try {
      let query = `$limit=1&$skip=0`; // Get the full document first
      if (client_id) query += `&values.client_id=${client_id}`;
      if (optionType) query += `&option_type=${optionType}`;

      const response = await axiosInstance.get(`/variant-attribute?${query}`);

      // Extract values array from response
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        const values = response.data.data[0].values || [];
        // Filter by search if provided
        const filtered = search
          ? values.filter((v) =>
              v.value.toLowerCase().includes(search.toLowerCase()),
            )
          : values;
        // Apply pagination
        const paginatedValues = filtered.slice(skip, skip + limit);
        // Transform to have a consistent format
        return {
          data: paginatedValues.map((v) => ({
            value: v.value,
          })),
          total: filtered.length,
        };
      }
      return { data: [], total: 0 };
    } catch (error) {
      throw error;
    }
  },
};
